/**
 * Tiny helper to mark whether the current browser session is an active
 * impersonation session. Used by axios interceptors to skip refresh
 * attempts for exchange-only impersonation tokens.
 */

const FLAG_KEY = 'optimo_impersonation_active'

export function setImpersonationActive(active: boolean): void {
    try {
        if (active) {
            window.sessionStorage.setItem(FLAG_KEY, '1')
        } else {
            window.sessionStorage.removeItem(FLAG_KEY)
        }
    } catch {
        // Non-blocking: storage may be unavailable
    }
}

export function isImpersonationActive(): boolean {
    try {
        return window.sessionStorage.getItem(FLAG_KEY) === '1'
    } catch {
        return false
    }
}

export function clearImpersonationFlag(): void {
    setImpersonationActive(false)
}
